import { render } from "./SeverTransHomePage.vue?vue&type=template&id=3bf732f0&scoped=true"
import script from "./SeverTransHomePage.vue?vue&type=script&lang=js"
export * from "./SeverTransHomePage.vue?vue&type=script&lang=js"

import "./SeverTransHomePage.vue?vue&type=style&index=0&id=3bf732f0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bf732f0"]])

export default __exports__